import React, { Dispatch, useState } from 'react';
import { Col, Input, Row, Form, Button, Modal, InputNumber } from 'antd';
import { CloseOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../../../store';
import { loadRequest } from '../../../../../../store/ducks/pedidoEntrega/actions';
import { IPedidoReq } from '../../../../../../store/ducks/pedidoEntrega/types';
import SelectCidade from '../../../../../../components/SelectCidade';
import SelectFornecedor from '../SelectFornecedor';
import SelectTipoVolume from './components/SelectTipoVolume';
import { StyledAsterisco } from './styles';
import SelectTomador from './components/SelectTomador/selectTomador';
import { SelectInscricao } from '../../../../../../components/SelectInscricao';
import {
  converterBRLToFloat,
  formatValueAsQuant,
  formatarPeso,
  formatarValorBRL,
} from '../../../../../../utils/mask';
import TitlePage from 'components/TitlePage';
import { ROLE } from 'utils/roles';
import { TextLabel } from 'components/TextLabel';
import Swal from 'sweetalert2';
import XML from '../../../../../../components/xml';

interface IProps {
  clienteRetira: boolean;
  selectedTranportadora: number;
  selectedTomador: number;
}

const ModalNovoItem: React.FC<IProps> = ({ selectedTranportadora, clienteRetira }) => {
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const dispatch = useDispatch<Dispatch<Action>>();
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const [selectedCidade, setSelectedCidade] = useState<any>();
  const [selectedFornecedor, setSelectedFornecedor] = useState<any>(false);
  const [modalNovoItemVisible, setModalNovoItemVisible] = useState(false);
  const [selectedTomador, setSelectedTomador] = useState<any>(false);

  const loadingPedidoEntrega = useSelector(
    (state: ApplicationState) => state.PedidoEntrega.loadingPedidoEntrega
  );

  const handleCancel = () => {
    setModalNovoItemVisible(false);
    form.resetFields();
  };

  const handleAdd = async (values: any) => {
    try {
      const valor = converterBRLToFloat(values.valor);
      const pedido: IPedidoReq = {
        chaveNfe: values.chaveNfe,
        codCdd: Number(cddAtivo?.codCdd),
        codDestinatario: Number(selectedTomador),
        codFornecedor: Number(selectedFornecedor),
        codTomador: Number(selectedTomador),
        codTransportadora: Number(selectedTranportadora),
        clienteEntrega: clienteRetira,
        valor: valor,
        numNota: values.numNota,
        pesoBruto: Number(values?.pesoBruto.replace(/\./g, "").replace(/,/g, ".")),
        codCidadeOrigem: Number(selectedCidade?.key),
        observacao: values.observacao,
        tipoVolume: values.tipoVolume,
        qtdVolume: Number(values.qtdVolume?.replace(/\D/g, '')),
      };

      dispatch(loadRequest({ pedido }));
      handleCancel();

    } catch (error: any) {
      if (error.response.data.Erro) {
        return Swal.fire({
          title: 'Opss...',
          html: `${error.response?.data?.Erro}`,
          icon: 'warning',
        });
      }

      return Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao tentar adicionar um novo documento, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    } finally {
    }
  };

  return (
    <>
      <Modal
        centered
        title={<TitlePage>Adicionar documento</TitlePage>}
        visible={modalNovoItemVisible}
        onCancel={() => handleCancel()}
        maskClosable={false}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={850}
        footer={[]}
      >
        <Form onFinish={(e) => handleAdd(e)} form={form}>
          <div className="boxinputs">
            <Row gutter={24}>
              <Col md={24} sm={24} xs={24}>
                <TextLabel>Chave da nota:</TextLabel>
                <Form.Item name="chaveNfe">
                  <Input type="text" maxLength={44} placeholder="Digite a chave da nota" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  <StyledAsterisco /> Tomador:
                </TextLabel>

                {perfil === ROLE.TRANSPORTADORA ? (
                  <Form.Item
                    // name="codTomador"
                    rules={[
                      {
                        required: true,
                        message: (
                          <span style={{ color: 'red' }}>Por favor, selecione o tomador</span>
                        ),
                      },
                    ]}
                  >
                    <SelectTomador setSelectedTomadorOrdemCarga={setSelectedTomador} />
                  </Form.Item>
                ) : (
                  <SelectInscricao setProps={setSelectedTomador} />
                )}
              </Col>
              <Col md={12} sm={24} xs={24}>
                <TextLabel>
                  <StyledAsterisco /> Fornecedor:
                </TextLabel>
                <SelectFornecedor setProps={setSelectedFornecedor} />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={8} sm={24} xs={24}>
                <TextLabel>
                  <StyledAsterisco /> Tipo de volume:
                </TextLabel>
                <SelectTipoVolume />
              </Col>

              <Col md={8} sm={24} xs={12}>
                <TextLabel>
                  <StyledAsterisco /> Quantidade:
                </TextLabel>
                <Form.Item
                  rules={[{ required: true, message: 'Digite a quantidade' }]}
                  name="qtdVolume"
                >
                  <Input
                    placeholder="Digite a quantidade"
                    min={0}
                    type="text"
                    style={{ width: '100%' }}
                    onChange={(e: any) => {
                      const value = formatValueAsQuant(e.target.value);
                      form.setFieldsValue({
                        qtdVolume: value,
                      });
                    }}
                  />
                </Form.Item>
              </Col>

              <Col md={8} sm={24} xs={12}>
                <TextLabel>
                  <StyledAsterisco /> N° da nota:
                </TextLabel>
                <Form.Item
                  name="numNota"
                  rules={[{ required: true, message: 'Digite o N° da Nota', type: 'number' }]}
                >
                  <InputNumber
                    placeholder="Digite somente números"
                    type="number"
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={8} sm={24} xs={12}>
                <TextLabel>
                  <StyledAsterisco /> Peso bruto:
                </TextLabel>
                <Form.Item rules={[{ required: true, message: 'Digite o Peso' }]} name="pesoBruto">
                  <Input
                    suffix="KG"
                    type="text"
                    onChange={(e: any) => {
                      const value = formatarPeso(e.target.value);
                      form.setFieldsValue({
                        pesoBruto: value,
                      });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col md={8} sm={24} xs={12}>
                <TextLabel>
                  <StyledAsterisco /> Valor total:
                </TextLabel>
                <Form.Item name="valor" rules={[{ required: true, message: 'Digite o Valor' }]}>
                  <Input
                    type="text"
                    onChange={(e: any) => {
                      const value = formatarValorBRL(e.target.value);

                      form.setFieldsValue({
                        valor: value,
                      });
                    }}
                  />
                </Form.Item>
              </Col>

              <Col md={8} sm={24} xs={24}>
                <TextLabel>
                  <StyledAsterisco /> Cidade de origem
                </TextLabel>
                <Form.Item rules={[{ required: true, message: 'Digite a Cidade' }]}>
                  <SelectCidade setProps={setSelectedCidade} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={24} sm={24} xs={24}>
                <TextLabel>Observação:</TextLabel>
                <Form.Item name="observacao">
                  <TextArea autoSize={{ minRows: 2, maxRows: 6 }} />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <Col style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              loading={loadingPedidoEntrega}
              type="primary"
              data-cy="btnSalvar"
              htmlType="submit"
              block
              icon={<SaveOutlined />}
              style={{ width: 'auto' }}
            >
              Salvar
            </Button>
          </Col>
        </Form>
      </Modal>
      <div style={{ padding: '50px  0px' }}>
        <div style={{ textAlign: 'left', fontWeight: 500, fontSize: '14px' }}>
          Adicione o documento
        </div>
        <Row gutter={24} style={{ display: 'flex', alignItems: 'center' }}>
          <Col md={6} sm={6} xs={6}>
            <XML clienteRetira={clienteRetira} selectedTranportadora={selectedTranportadora} />
          </Col>

          <Col md={6} sm={6} xs={6}>
            <Button
              data-cy="btnAddDocumento"
              type="primary"
              htmlType="submit"
              block
              onClick={() => setModalNovoItemVisible(true)}
              style={{ fontWeight: 500, letterSpacing: '0.5px' }}
            >
              <PlusOutlined /> Adicionar manualmente
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ModalNovoItem;
